import PropTypes from 'prop-types';
import React from 'react';
import CheckBox from '../../../Content/Elements/CheckBox/CheckBox';
import SVGFromCloudinary from '../../../Elements/SVGFromCloudinary/SVGFromCloudinary';

import './JobSearchFilterListSection.scss';

export default class JobSearchFilterListSection extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * display name of a search filter
         */
        title: PropTypes.string,
        /**
         * display count of a search filter
         */
        count: PropTypes.number,
        /**
         * unique identifier of a search filter
         */
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /**
         * checked/unchecked state of a search filter
         */
        active: PropTypes.bool,
        /**
         * click handler for checkbox
         */
        onClick: PropTypes.func,
        /**
         * optional CSS class
         */
        className: PropTypes.string,
        /*
         * path for a search filter image
         */
        image: PropTypes.string,
    };

    static defaultProps = {
        title: '',
        count: 0,
        value: null,
        active: false,
        onClick: () => {},
        className: '',
        image: '',
    };

    render() {
        const activeClass = this.props.active ? 'active' : '';
        const { count, title, className, image } = this.props;

        return (
            <div
                className={`component-Jobs-JobSearchFilter-JobSearchFilterListSection ${activeClass}`}
            >
                <div className={className}>
                    {image && (
                        <SVGFromCloudinary
                            className="search-filter-icon"
                            alt="quick apply icon"
                            cloudinaryID={image}
                        />
                    )}
                    {`${title} ${count ? `(${count})` : ''}`}
                </div>
                <CheckBox
                    id={String(this.props.value)}
                    inputValue={this.props.value}
                    defaultChecked={this.props.active}
                    handleChange={(value) =>
                        this.props.onClick(value, this.props.value)
                    }
                    className={'empty-circle'}
                />
            </div>
        );
    }
}
